import { TimePicker } from "antd";
import dayjs from "dayjs";
import React from "react";

export const MyTimePicker = ({
  disabled = false,
  onChange,
  value,
  placeholder,
  format = "HH:mm",
  size = "",
}) => {
  return (
    <TimePicker
      size={size}
      placeholder={placeholder}
      changeOnScroll
      format={format}
      disabled={disabled}
      minuteStep={10}
      inputReadOnly
      onChange={(e) => {
        if (!e) return;
        const normalized = e.second(0).millisecond(0);
        const time = normalized?.format("HH:mm:ss") || "";
        onChange(time);
      }}
      value={value ? dayjs(value, "HH:mm") : null}
    />
  );
};
